import React from 'react'

import { Typography, Link } from '@mui/material'

const LinkCell = ({ value, href = '#', _typo, _link, }) =>
  <Typography {..._typo} sx={{ textAlign: 'center', ..._typo?.sx }}>
    {!!value
      ? <Link {..._link} href={href} target={'_blank'} sx={{ color: 'inherit', textDecorationColor: 'inherit', ..._link?.sx }}>
        {value}
      </Link>
      : '-'
    }
  </Typography>

export default React.memo(LinkCell)
